<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="04" :question="question" :modalActivator="modalActivator"
            @activateModal="modalActive = true"></QuestionTitle>
        <div class="container-70 mt-20px">
            <SelectOptionBox :img="imgAlimentation" :options="options" v-model="result"></SelectOptionBox>
            <div v-if="result != null" @click="saveAndContinue('residenceType', JSON.stringify(result), './question-5')"
                class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine class="mt-50px" percent="80%"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive = false" v-if="modalActive">
            <h3 class="modal-title">GES émis par votre habitation</h3>
            <p class="modal-text">Les GES émis par un bâtiment relèvent principalement de la consommation énergétique nécessaire pour le chauffer. Plusieurs facteurs déterminent la quantité de GES émis, tels que la source d'énergie utilisée, les besoins et habitudes de consommation d'énergie, la performance énergétique du bâtiment, ainsi que sa superficie.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result: null,
            modalActive: false,
            modalActivator:true,
            question: 'Dans quel type de résidence habitez-vous?',
            imgAlimentation: require('@/assets/images/house_2.png'),
            options: [
                {
                    label: "Appartement/condo 2 1/2",
                    value: "Appartement/condo 2 1/2"
                },
                {
                    label: "Appartement/condo 3 1/2",
                    value: "Appartement/condo 3 1/2"
                },
                {
                    label: "Appartement/condo 4 1/2",
                    value: "Appartement/condo 4 1/2"
                },
                {
                    label: "Appartement/condo 5 1/2",
                    value: "Appartement/condo 5 1/2"
                },
                {
                    label: "Appartement/condo 6 1/2",
                    value: "Appartement/condo 6 1/2"
                },
                {
                    label: "Maison (moins de 3 chambres)",
                    value: "Maison (moins de 3 chambres)"
                },  
                {
                    label: "Maison (3 à 5 chambres)",
                    value: "Maison (3 à 5 chambres)"
                },  
                {
                    label: "Maison (6 chambres et plus)",
                    value: "Maison (6 chambres et plus)"
                },  
                {
                    label: "Maison de luxe",
                    value: "Maison de luxe"
                }
            ]

        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        SelectOptionBox,
        ModalInfo
    },
    mixins: [utils],
    mounted() {
        if (sessionStorage.getItem('residenceType')) {
            this.result = JSON.parse(sessionStorage.getItem('residenceType'))
        }
    }
}
</script>